import { render, staticRenderFns } from "./OnboardingScreenEditor.vue?vue&type=template&id=a8b3090a&"
import script from "./OnboardingScreenEditor.vue?vue&type=script&lang=js&"
export * from "./OnboardingScreenEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports